// Vite exposes env vars on import.meta.env, and only VITE_* keys are public.
const env = import.meta.env;

export const base_url = env.VITE_API_URL;
export const tile_base_url = env.VITE_TILE_IMAGE_BASE_URL || "";
export const image_base_url = env.VITE_IMAGE_URL || "";

export const init_request_url = `${base_url}?method=init`;
export const get_all_cities_url = `${base_url}?method=get_all_cities`;
export const get_all_streets_by_city_url = `${base_url}?method=get_all_streets_by_city`;
export const get_delivery_request_url = `${base_url}?method=get_delivery&delivery_v2=true`;
export const set_newsletter_request_url = `${base_url}?method=set_newsletter`;
export const get_thanks_page_status_request_url = `${base_url}?method=get_thanks_page_status`;
export const get_basket_request_url = `${base_url}?method=get_basket`;
export const delete_item_request_url = `${base_url}?method=delete_item`;
export const payment_link_request_url = `${base_url}?method=payment_link`;
export const update_item_request_url = `${base_url}?method=update_item`;
export const get_shipping_methods_url = `${base_url}?method=get_delivery`;
export const bhshops_get_all_cities_url = `${base_url}?method=get_city_list`;
export const bhshops_get_all_collection_points_url = `${base_url}?method=get_shop_sites_by_city`;
export const set_birth_date_url = `${base_url}?method=set_birth_date`;
export const get_desktop_orders_url = `${base_url}?method=get_desktop_orders`;
export const get_coupons_url = `${base_url}?method=get_coupons`;
export const check_coupon_url = `${base_url}?method=check_coupon`;
export const get_is_special_city_url = `${base_url}?method=is_special_city`;
export const post_credit_guard_screen_url = `${base_url}?method=credit_guard_screen`;
export const remove_coupon_url = `${base_url}?method=remove_coupon`;
